export const PLACEHOLDERS = [
  '{{full_name}}',
  '{{first_name}}',
  '{{last_name}}',
  '{{email}}',
  '{{employee_code}}',
  '{{department}}',
  '{{role}}',
  '{{position}}',
  '{{status}}',
  '{{site}}',
  '{{cost_center}}',
  '{{contract_type}}',
  '{{nationality}}',
  '{{joining_date}}',
  '{{today}}',
  '{{current_year}}',
  '{{app_name}}',
  '{{company_name}}',
];

export function insertPlaceholder(source = '', placeholder = '{{first_name}}', cursorPosition = null) {
  const text = String(source || '');
  const token = String(placeholder || '{{first_name}}');

  if (cursorPosition === null || Number.isNaN(Number(cursorPosition))) {
    return `${text}${token}`;
  }

  const index = Math.max(0, Math.min(text.length, Number(cursorPosition)));
  return `${text.slice(0, index)}${token}${text.slice(index)}`;
}

export default insertPlaceholder;
